import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getAccountCategoryList } from '@store/Finance/ChartAccounts/ChartAccountsSlice';
import { useTranslation } from 'react-i18next';
import type { TreeSelectProps } from 'antd';

// تعريف نوع العقدة في الشجرة
interface TreeNode {
  title: string;
  value: string;
  children?: TreeNode[];
}

// نوع البيانات للشجرة (بما في ذلك العقد الفرعية)
type TreeDataNode = any;

const useGetAccountCategory = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data?.length === 0) {
      dispatch(getAccountCategoryList());
    }
  }, []);
  const { AccountCategoryList: data, loading2: loading, error2: error } = useAppSelector(state => state.ChartAccounts);

  //___ Options _____
  const OptionsAccountCategory = data?.map(({ id, name, name2 }) => ({
    value: id,
    label: `${i18n.language === 'en' ? name : name2}`
  }));

  //_______

  // تجهيز البيانات في شكل nested grouping

  const grouped = data.reduce((acc: any, item: any) => {
    if (!acc[item.mainCategory]) acc[item.mainCategory] = {};
    if (!acc[item.mainCategory][item.parentCategory]) acc[item.mainCategory][item.parentCategory] = [];
    acc[item.mainCategory][item.parentCategory].push(item);
    return acc;
  }, {});

  // const treeDataAccountCategory = useMemo(() => {
  //   // أولاً نجمع حسب mainCategory
  //   const grouped: Record<string, any> = {};

  //   data.forEach(item => {
  //     if (!grouped[item.mainCategory]) {
  //       grouped[item.mainCategory] = {};
  //     }
  //     if (!grouped[item.mainCategory][item.parentCategory]) {
  //       grouped[item.mainCategory][item.parentCategory] = [];
  //     }
  //     grouped[item.mainCategory][item.parentCategory].push({
  //       title: `${item.name2} (${item.name})`, // يعرض العربي + الإنجليزي
  //       value: item.id,
  //       key: item.id
  //     });
  //   });

  //   // نحولها لشكل antd treeData
  //   return Object.entries(grouped).map(([mainCategory, parents]) => ({
  //     title: mainCategory,
  //     value: mainCategory,
  //     key: mainCategory,
  //     children: Object.entries(parents).map(([parentCategory, children]) => ({
  //       title: parentCategory,
  //       value: `${mainCategory}-${parentCategory}`,
  //       key: `${mainCategory}-${parentCategory}`,
  //       children
  //     }))
  //   }));
  // }, []);

  // console.log(treeData);

  // دالة لتحويل النصوص الرئيسية إلى العربية
  const getArabicMainCategory = (key: string): string => {
    const map: Record<string, string> = {
      BalanceSheet: 'الميزانية العمومية',
      ProfitAndLoss: 'الأرباح والخسائر',
      Other: 'آخر'
    };
    return map[key] || key;
  };

  // دالة لتحويل الفئات الفرعية إلى العربية
  const getArabicParentCategory = (key: string): string => {
    const map: Record<string, string> = {
      Assets: 'أصول',
      Liabilities: 'خصوم',
      Equity: 'حقوق ملكية',
      Income: 'إيرادات',
      Expense: 'مصروفات',
      Other: 'آخر'
    };
    return map[key] || key;
  };

  // بناء الهيكل الشجري
  const buildTree = (): TreeDataNode[] => {
    // هيكل تخزين مؤقت: mainCategory -> parentCategory -> nodes[]
    const tree: Record<string, { node: TreeDataNode; children: Record<string, TreeDataNode> }> = {};

    data.forEach(item => {
      const { mainCategory, parentCategory, name, name2, id } = item;

      // إنشاء mainCategory إذا لم يكن موجودًا
      if (!tree[mainCategory]) {
        tree[mainCategory] = {
          node: {
            // title: `${mainCategory} - ${getArabicMainCategory(mainCategory)}`,
            title: (
              <span className='text-theme fw-bold '>
                {mainCategory} - {getArabicMainCategory(mainCategory)}
              </span>
            ),
            value: mainCategory,
            disabled: true // تعطيل العقدة الأم (لأن لها أبناء)
          },
          children: {}
        };
      }

      // إنشاء parentCategory تحت mainCategory
      if (!tree[mainCategory].children[parentCategory]) {
        tree[mainCategory].children[parentCategory] = {
          title: (
            <span className='text-theme fw-bold'>
              ${parentCategory} - {getArabicParentCategory(parentCategory)}
            </span>
          ),

          value: `${mainCategory}-${parentCategory}`,
          disabled: true, // تعطيل الفئة الفرعية (لأنها تحتوي على أبناء)
          children: []
        };
      }

      // إضافة العقدة النهائية (الحساب)
      tree[mainCategory].children[parentCategory].children!.push({
        title: `${name} - ${name2}`,
        value: id
      });
    });

    // تحويل الهيكل إلى مصفوفة من العقد
    return Object.values(tree).map(({ node, children }) => ({
      ...node,
      children: Object.values(children)
    }));
  };

  const treeDataAccountCategory = buildTree();

  return {
    AccountCategoryList: data,
    OptionsAccountCategory,
    treeDataAccountCategory,
    grouped,
    loading,
    error
  };
};

export default useGetAccountCategory;
